import type { ReactElement } from 'react';

import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';

const Component = ({ className }: { className: string }): ReactElement => {
	const theme = useTheme() as Theme;
	return (
		<div className={className}>
			<svg fill="none" viewBox="0 0 16 12">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.753 6.224a.832.832 0 1 0-1.2 1.153L3.078 10 9.41 3.779a.835.835 0 0 0-1.166-1.195L3.076 7.6 1.753 6.224Z"
					fill={theme.chat.icons.messageReadIcon.fill}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.154 5.6 6 6.8 9.077 10l6.334-6.221a.835.835 0 0 0-1.166-1.195L9.076 7.6l-1.923-2Z"
					fill={theme.chat.icons.messageReadIcon.fill}
				/>
			</svg>
		</div>
	);
};

export const MessageReadIcon = styled(Component)(
	({
		theme: {
			chat: {
				icons: { messageReadIcon },
			},
		},
	}: {
		theme: Theme;
	}) => ({
		marginLeft: '5px',
		position: 'relative',
		...messageReadIcon,
		'& svg': {
			bottom: '-1px',
			position: 'absolute',
			left: '0',
		},
	})
);
